import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useRef, useCallback } from 'react';


const useLazyLoad = (slice: any, fetchAction: (page: number) => any ) => {
    const dispatch = useDispatch();
    const paginationRef = useRef<HTMLDivElement>(null);

    const { data, isFetching, error, currentPage, lastPage } = useSelector((state: any) => state[slice.name]);

    useEffect(() => {
        dispatch(fetchAction(currentPage));
    }, [currentPage, dispatch, fetchAction]);

    const handleScroll = useCallback(() => {
        if (paginationRef.current) {
            const { scrollTop } = document.documentElement;
            const wrapperBottom = paginationRef.current.getBoundingClientRect().bottom + scrollTop;

            if ((window.scrollY + window.innerHeight) >= wrapperBottom) {
                if (currentPage < lastPage && !isFetching) {
                    dispatch(slice.actions.incrementPage());
                }
            }
        }
    }, [currentPage, lastPage, isFetching, dispatch, slice.actions]);

    useEffect(() => {
        handleScroll();
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [handleScroll]);

    return { data, isFetching, error, paginationRef, currentPage };
};

export default useLazyLoad;
